import { InjectionToken } from '@angular/core';

import { IPageService } from './page-service.model';

export const PAGE_SERVICE = new InjectionToken<IPageService<unknown>>('PAGE_SERVICE');
